import { Box, alpha } from '@mui/material';
import { type ReactNode } from 'react';

interface ToolGroupProps {
    children: ReactNode;
}

/**
 * Wraps a related set of toolbar buttons in a subtly tinted, rounded "well"
 * so the step toolbar reads as distinct clusters (view manipulation vs.
 * editing vs. history) instead of one undifferentiated row. Buttons within a
 * group sit closer together than the gap between groups, reinforcing the
 * grouping by proximity. Replaces the old thin vertical dividers.
 *
 * The toolbar sits on a fixed dark glass overlay (theme-mode independent), so
 * the well tints are expressed relative to that dark backdrop.
 */
export default function ToolGroup({ children }: ToolGroupProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
                px: 0.5,
                py: 0.25,
                borderRadius: 1,
                backgroundColor: alpha('#ffffff', 0.05),
                border: '1px solid',
                borderColor: alpha('#ffffff', 0.08),
            }}
        >
            {children}
        </Box>
    );
}
